var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"like-btn",class:{active: _vm.likedByMe},style:(_vm.style),on:{"click":_vm.toggleLike}},[_c('i',{staticClass:"far fa-thumbs-up"}),_vm._v("\n  "+_vm._s(_vm.$t('likeButton.msg'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }